<template>
    <div class="view--home">
        <p>Choose your plan:</p>
        <router-link to="/process">Demo Process</router-link>
    </div>
</template>

<script>
export default {
  name: 'home',
  components: {},
};
</script>
